<div class="content">
  <div class="content__header">
    <div class="content__header__logo w-64">
      <img src="assets/images/logos/field_logo.svg" />
    </div>
    <h1 class="content__header__title">
      {{ 'NET_PROMOTER_SCORE.SCORE_STEP.TITLE' | translate }}
    </h1>
  </div>
  <div class="content__container">
    <div class="content__container__buttons">
      <button
        class="content__container__button"
        *ngFor="let slot of slots; index as index"
        (click)="setScore(slot.value)"
        (mouseover)="onHover(slot.value)"
        [style.background-color]="index <= score || index <= hoverIndex ? slot.color : '#B3B3B3'"
        [style.opacity]="index > score && index < hoverIndex ? 0.5 : 1"
      >
        {{ slot.value }}
      </button>
    </div>
    <p class="content__description">
      {{ 'NET_PROMOTER_SCORE.SCORE_STEP.DESCRIPTION' | translate }}
    </p>
  </div>

  <button
    mat-flat-button
    [disabled]="score < 0"
    (click)="nextStep()"
    color="primary"
    type="button"
    class="content__next_button"
  >
    {{ 'NET_PROMOTER_SCORE.BUTTONS.NEXT' | translate }}
  </button>
</div>
